import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import Loader from 'src/shared/components/loader/Loader';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import useAuthService from 'src/shared/hooks/useAuthService';
import { redirectToShopify } from 'src/shared/utils/redirect';
import loginStorageService from '../services/login-storage-service';

/**
 * The entry point for a sign-in. Shopify sends users here with `?shopify=true` to sign in with their
 * NatureMetrics account. A signed-in user goes back to Shopify at once. Other users go to the login,
 * and the `'shopify'` redirect path tells the OAuth callback to send them back to Shopify after it.
 */
const Signin = () => {
    const { isAuthenticated, hasGivenTncConsent } = useAuthService();
    const navigate = useAppNavigation();
    const [searchParams] = useSearchParams();
    const redirectTo = searchParams.get('redirectTo');
    const shopify = searchParams.get('shopify');

    useEffect(() => {
        if (redirectTo) {
            loginStorageService.setRedirectPath(redirectTo);
        }
        if (shopify) {
            loginStorageService.setRedirectPath('shopify');
        }

        if (isAuthenticated && hasGivenTncConsent) {
            if (shopify) {
                redirectToShopify();
            } else {
                navigate.toPostAuthRedirect();
            }
        } else if (!isAuthenticated) {
            navigate.toLogin();
        }
    }, [isAuthenticated, shopify]);

    return <Loader />;
};
export default Signin;
